import React from "react";
import { connect } from "react-redux";
import { updateColor } from "../../../../actions";
import { bindActionCreators } from "redux";

class Color extends React.Component {
  onUpdateColor(option) {
    // TODO: we could take this out now that you can't click add to cart when your color is out of stock
    if (
      !this.props.color.out_of_stock_until ||
      (this.props.user.loggedIn && this.props.user.isAdmin)
    ) {
      this.props.updateColor(option);
    }
  }

  render() {
    let selected = "";
    this.props.design.layer_set.forEach((layer) => {
      if (layer.id === this.props.layerId) {
        if (this.props.type === "Paper") {
          selected = layer.color.id === this.props.color.id ? "selected" : "";
        } else {
          selected =
            layer.print_color.id === this.props.color.id ? "selected" : "";
        }
      }
    });
    /*
    let outofstock = ''
    if (this.props.color.out_of_stock_until !== '') {
      outofstock = 'Out Till: ' + this.props.color.out_of_stock_until
    }
    */
   const isOutOfStock = this.props.color.out_of_stock_until !== "";

    return (
      <div
        id={`color-${this.props.color.id}`}
        className={`color color-container ${selected} ${isOutOfStock ? "out-of-stock" : ""}`}
        onClick={() =>
          this.onUpdateColor({
            color: this.props.color,
            type: this.props.type,
            layerId: this.props.layerId,
          })
        }
      >
        <div className="color__thumbnail">
          <img src={this.props.color.thumbnail} alt="" />
          {isOutOfStock && <div className="out-of-stock-overlay"></div>}
        </div>
        <div className="color__hover">
          {this.props.color.name}
          {isOutOfStock && (
           <div className="outtill">
            Out Until: {this.props.color.out_of_stock_until}
           </div>
          )}
        </div>
      </div>
    );
  }
  //{/*style={{backgroundColor: `rgb(${this.props.color.colorValue})`}}*/}
}

function mapStateToProps(state) {
  return {
    user: state.user,
    design: state.design.present,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selecToolCollection to reducers
  return bindActionCreators({ updateColor: updateColor }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Color);
